<div style="width: 100%; text-align: center">
  <div>    
    <h1>Su código Qr para ingresar a las piscinas es:</h1>
  </div>

  <div>    
    <p>Click en el botón para guardar su código QR</p>
  </div>

  <p class="negrilla">
    Descarguelo o imprimalo para presentarlo al ingresar al complejo deportivo, este link se inactivará
  </p>

  <div class="qrcodeImage place-content-center" style="cursor: pointer;">
      <qrcode [qrdata]="id" [width]="innerWidth" #imgCodigo (click)="descargarImagen($event)" [errorCorrectionLevel]="'M'" [cssClass]="'demoBorder'"></qrcode>
  </div>



  <p *ngIf="data">
    Fecha límite de ingreso: {{ data[0] | date: "dd-MM-yyyy" }}
  </p>

  <div *ngIf="!data">
    <span> El código no tiene horarios asignados </span>
  </div>
</div>

<div *ngIf="data">
  <ul *ngFor="let horario of data[1]">
    <li>
      {{ horario.dias }} -- Desde : {{ horario.horaInicio }} a
      {{ horario.horaFin }}
    </li>
  </ul>
</div>
